import React from 'react';
import { toggleTheme } from '../../../redux/slice/ThemeSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks/Hooks';
import { DarkThemeIcon, LightThemeIcon } from "../../../assets/svgIcons/svgIcons";
// import './ThemeToggle.scss';

const ThemeToggle: React.FC = () => {
  const dispatch = useAppDispatch();
  const theme = useAppSelector((state) => state.theme.theme);

  return (
    <button 
      className="theme_toggle_button"
      onClick={() => dispatch(toggleTheme())}
    >
      {/* Switch to  */}
      {theme === 'dark' ? <LightThemeIcon/> : <DarkThemeIcon/>} 
      {/* Theme */}
    </button>
  );
};

export default ThemeToggle;